import { useEffect } from 'react'

const useEnterKey = (callback: () => void) => {
  useEffect(() => {
    const handleKeyUp = (e: KeyboardEvent) => {
      if (e.key === 'Enter') {
        callback()
      }
    }

    window.addEventListener('keyup', handleKeyUp)
    return () => window.removeEventListener('keyup', handleKeyUp)
  }, [callback])
}

export default useEnterKey
